<template>
   <v-container fluid>
      <v-row>
         <v-col cols="12" md="12">
            <v-toolbar dense color="primary white--text" bottom>
               <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                  CCA Proposal
               </v-toolbar-title>
               <v-icon color="white" v-else>mdi-folder</v-icon>
            </v-toolbar>
         </v-col>
         <v-toolbar>
            <template v-if="ProposalSubmissionNotOpen">
               <v-spacer></v-spacer>
               <p>CCA Proposal is not opened for submission.</p>
               <v-spacer></v-spacer>
            </template>
            <template v-else-if="ProposalSubmissionClosed">
               <v-spacer></v-spacer>
               <p>CCA Proposal is closed for submission.</p>
               <v-spacer></v-spacer>
            </template>
            <template v-else>
               <v-btn class="ma-2" small outlined color="indigo" @click="createProposal">
                  <v-icon left>mdi-plus</v-icon>
                  <div v-if="$vuetify.breakpoint.mdAndUp">Create Proposal</div>
               </v-btn>
            </template>
         </v-toolbar>
      </v-row>
      <v-row dense justify="center" class="mt-4 px-2">
         <v-col cols="12" md="11">
            <v-card>
               <v-data-table
                  dense
                  :items="proposaldata"
                  :headers="form_header"
                  single-select
                  hide-default-footer
                  @click:row="formRowClick"
               >
               </v-data-table>
            </v-card>
         </v-col>
      </v-row>
   </v-container>
</template>

<script>
   export default {
      inject: ["ShowMessage"],

      data() {
         return {
            MAX_PROPOSAL: 3,
            proposaldata: [],
            form_header: [
               {
                  text: "Year/Term",
                  value: "yeartermtext",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Name",
                  value: "cca_name",
                  width: "30%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Role",
                  value: "roletext",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Submitted",
                  value: "createdate",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Status",
                  value: "adminstatustext",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
            ],
         };
      },
      computed: {
         ProposalSubmissionNotOpen() {
            if (this.$globalstore && this.$globalstore.appready) {
               return this.todayDate() < this.$globalstore.appsettings.proposal_opendate;
            } else {
               return true;
            }
         },

         ProposalSubmissionClosed() {
            if (this.$globalstore && this.$globalstore.appready) {
               return this.todayDate() > this.$globalstore.appsettings.proposal_closedate;
            } else {
               return true;
            }
         },
      },

      methods: {
         todayDate() {
            return this.$globalstore.currentDateISOString().substr(0, 10);
         },

         formRowClick(item, row) {
            row.select(!row.isSelected);
         },

         async loadUserProposal() {
            let response = await this.$http({
               url: "/cca/getuserproposal.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.$globalstore.appsettings.proposal_year,
                  cca_term: this.$globalstore.appsettings.proposal_term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.proposaldata = response.data.proposaldata;
                  }
               }
            });
         },

         createProposal() {
            if (this.proposaldata.length === this.MAX_PROPOSAL) {
               this.ShowMessage({
                  title: "Info",
                  message: "You may submit a maximum of " + this.MAX_PROPOSAL + " proposals.",
                  color: "primary",
               });
            } else {
               this.$router.push({name: "CCAProposalForm"});
            }
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.loadUserProposal();
         }
      },
   };
</script>
